<script setup lang="ts">
import { computed } from 'vue'

import { AdWrapper } from '@toni/brand-ui'

import { useAd } from '../../advertisement/composables/use-ad'
import AdSlot from './AdSlot.vue'
import WallpaperAd from './WallpaperAd.vue'
import { useRegisterAdSlot } from '../../advertisement/composables/use-ad-slots'

const { slotName, minWidth, minHeight } = useAd('header', 1)
const { registeredAdSlots } = useRegisterAdSlot()

const isSkyscraperRegistered = computed(() => {
  return registeredAdSlots.value.some((slot) => slot === 'skyscraper_1')
})

</script>

<template>
  <AdWrapper v-if="slotName"
             slot-name="combined_desktop_ads"
             data-testid="ad-slot">
    <WallpaperAd v-if="isSkyscraperRegistered" />
    <AdSlot :min-width="minWidth"
            :min-height="minHeight"
            :slot-name="slotName" />
  </AdWrapper>
</template>
